module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "headText"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "homePage"
  }, [_c('li', [_c('router-link', {
    staticStyle: {
      "color": "#ffffff",
      "font-weight": "600"
    },
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('span', {
    staticClass: "zhUnder"
  })], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/courseList"
    }
  }, [_vm._v("课程")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/AboutEnoch"
    }
  }, [_vm._v("关于以诺")])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "picture"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/logo1.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b85e081","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IndexHead/IndexHead.vue
// module id = 539
// module chunks = 1